'use client'

import classNames from 'classnames'

import Icon from '../Icon'
import PaginationButton from './components/PaginationButton'

type PaginationProps = {
  pagination: number[]
  page: number
  totalPages: number
  setPage: (number: number) => void
}

export default function Pagination({ page, pagination, totalPages, setPage }: PaginationProps) {
  return (
    <ul className='flex items-center gap-4'>
      <li className='flex items-center'>
        <PaginationButton
          onPress={() => {
            setPage(page - 1)
          }}
          isDisabled={page === 1}
          className={classNames(
            page > 1 ? 'text-black' : 'text-darkgray',
            'h5 flex items-center justify-center px-1 py-1 transition-colors',
          )}
        >
          <Icon name='MdChevronLeft' size={24} />
        </PaginationButton>
      </li>

      {pagination.map(item => (
        <li key={item} className='flex items-center'>
          <PaginationButton
            onPress={() => {
              setPage(item)
            }}
            isDisabled={page === item}
          >
            <p
              className={classNames(
                page === item ? 'text-black' : 'text-darkgray',
                'h5 px-2 transition-colors',
              )}
            >
              {item}
            </p>
          </PaginationButton>
        </li>
      ))}

      <li className='flex items-center'>
        <PaginationButton
          onPress={() => {
            setPage(page + 1)
          }}
          className={classNames(
            page < totalPages ? 'text-black' : 'text-darkgray',
            'h5 flex items-center justify-center px-1 py-1 transition-colors',
          )}
          isDisabled={page === totalPages}
        >
          <Icon name='MdChevronRight' size={24} />
        </PaginationButton>
      </li>
    </ul>
  )
}
